<template>
    <div v-show="warningVisible">
        <input type="hidden" id="timerState">
        <div class="row">
            <div class="col-lg-12">
                <div v-for="elem in messages" class="alert bg-danger" style="font-size: 24px">
                    <p  class="font-weight-bolder"> <i class="fas fa-exclamation-triangle mr-2"></i>{{elem}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "ServiceAlert",
    data: function () {
        return {
            warningVisible: false,
            messages : null,
        }
    },
    methods:{
        checkServices:function (){
            const _this = this;
            axios.get("/superadmin/service-alert")
                .then(function (response) {
                    if((response.data).length > 0){
                        _this.warningVisible = true;
                        _this.messages = response.data;
                    }
                    else{
                        _this.warningVisible = false;
                    }
                });
        }
    },
    mounted: function () {
        this.checkServices()
        window.setInterval(() => {
            this.checkServices();
        },1000 * 60);
    },
}
</script>

<style scoped>

</style>
